export const getLRSIdVerificationNeeded = (state: Record<string, any>) => {
  const {
    entities: {
      lrs: { idVerificationNeeded },
    },
  } = state;

  return idVerificationNeeded;
};

export const getLRSPreviousPayments = (state: Record<string, any>) => {
  const {
    entities: {
      lrs: { previousPayments },
    },
  } = state;

  return previousPayments;
};

export const lrsSignatureUploadFailed = (state: Record<string, any>) => {
  const {
    entities: {
      lrs: { signatureUploadFailed },
    },
  } = state;

  return !!signatureUploadFailed;
};
